<h1>{{ 'T4.Service.ServiceMessageDialog.HeadTitle' | translate : dialogTitle }} {{dialogInfoTitle ? " - " + dialogInfoTitle : ""}}</h1>
<mat-dialog-content> 
  <t4-container>
    <div style="display:flex;gap:12px;align-items:end;flex-wrap:wrap;">
      <!--<mat-form-field style="min-width:200px;">
        <mat-label>{{ 'T4.Service.ServiceMessageDialog.lblTemplate' | translate : 'Template' }}</mat-label>
        <mat-select [(value)]="selectedTemplateKey" (selectionChange)="onTemplateKeyChange($event.value) ;  insertTemplateContent()">
          <mat-option *ngFor="let k of templateKeys" [value]="k">{{k}}</mat-option>
        </mat-select> 
      </mat-form-field>-->

      <mat-form-field style="min-width:200px;">
        <!----<mat-label>{{ 'T4.Service.ServiceMessageDialog.lblLanguage' | translate : 'Language' }}</mat-label> -->
        <mat-label>{{ 'T4.Service.ServiceMessageDialog.lblTemplate' | translate : 'Template' }}</mat-label>
        <mat-select [(value)]="selectedFriendlyName" (selectionChange)="onFriendlyNameChange($event.value); insertTemplateContent()">
          <mat-option *ngFor="let t of filteredTemplates" [value]="t.FriendlyName">{{t.FriendlyName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field style="width:100%;margin-top:12px;">
      <mat-label>{{ 'T4.Service.ServiceMessageDialog.lblMessage' | translate : 'Message' }}</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="15"
                [(ngModel)]="message"></textarea>
    </mat-form-field>
    <div style="display: flex; justify-content: flex-end;">
      <button mat-flat-button color="primary" (click)="closeDialog()"> {{ 'T4.Service.ServiceMessageDialog.btnSend' | translate : 'Send' }}</button>
    </div>
  </t4-container>
</mat-dialog-content>
